import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartPie } from 'common/charts';
import { fetchCasesReports } from 'actions/Report/Case';
import _ from 'lodash';

export default class CasesByServiceType extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      casesByServiceType: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.filters, nextProps.filters)) {
      this.fetchData(nextProps.filters);
    }
  }

  fetchData(filters) {
    const { scope, id } = this.props;
    fetchCasesReports(scope, id, 'by-service-type', filters)
      .then((response) => {
        this.setState({
          casesByServiceType: _.orderBy(_.get(response, 'data.values', []), 'title', 'asc'),
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('casesByServiceType');
      });
  }

  render() {
    if (_.isEmpty(this.state.casesByServiceType)) {
      return null;
    }
    return (
      <ChartPie
        data={this.state.casesByServiceType}
        style={{ height: '350px' }}
        title={this.state.title}
        valueFormat="d"
        x={(d) => d.title}
        y={(d) => d.total}
      />
    );
  }
}

CasesByServiceType.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
